export const THIRTY_PERCENT_OFF_QUARTERLY = '30pctOffQuarterly'
export const THIRTY_PERCENT_OFF_QUARTERLY_TOTAL = '30pctOffQuarterlyTotal'

type TPricingPlanType = 'gold' | 'pro'
type TPricingPlanPeriod =
  | 'monthly'
  | 'quarterly'
  | 'quarterlyTotal'
  | typeof THIRTY_PERCENT_OFF_QUARTERLY
  | typeof THIRTY_PERCENT_OFF_QUARTERLY_TOTAL

export const PRICING_PLAN_AMOUNTS: Record<
  TPricingPlanType,
  Record<TPricingPlanPeriod, null | string>
> = {
  gold: {
    [THIRTY_PERCENT_OFF_QUARTERLY]: '30.31',
    [THIRTY_PERCENT_OFF_QUARTERLY_TOTAL]: '91.00',
    monthly: '49.00',
    quarterly: '43.33',
    quarterlyTotal: '130.00',
  },
  pro: {
    [THIRTY_PERCENT_OFF_QUARTERLY]: '11.43',
    [THIRTY_PERCENT_OFF_QUARTERLY_TOTAL]: '34.30',
    monthly: '19.00',
    quarterly: '16.33',
    quarterlyTotal: '49.00',
  },
}

export const PRICING_PLAN_SAVINGS_AMOUNTS: Record<
  TPricingPlanType,
  Record<'quarterly' | typeof THIRTY_PERCENT_OFF_QUARTERLY, number>
> = {
  gold: {
    [THIRTY_PERCENT_OFF_QUARTERLY]: 56,
    quarterly: 19,
  },
  pro: {
    [THIRTY_PERCENT_OFF_QUARTERLY]: 22,
    quarterly: 9,
  },
}

type TDiscountType = 'quarterly' | typeof THIRTY_PERCENT_OFF_QUARTERLY

// The quarterly discount percentage is ~14%
// 30% off quarterly the original quarterly price of compared to monthly price ($19) is 40% delta
export const PRICING_PLAN_DISCOUNT_PERCENTAGES: Record<TDiscountType, number> = {
  [THIRTY_PERCENT_OFF_QUARTERLY]: 40,
  quarterly: 14,
}

type TPricingPlanName = 'gold' | 'pro' | 'starter'

export const PRICING_PLAN_NAMES: Record<TPricingPlanName, string> = {
  gold: 'Gold',
  pro: 'Pro',
  starter: 'Starter',
}

type TDiscountCode = '30pctOffGold' | '30pctOffPro'

export const PLAN_DISCOUNT_CODES: Record<TDiscountCode, string> = {
  '30pctOffGold': 'a10RJBkY',
  '30pctOffPro': 'Ed0XqRMI',
}

export const LIMITED_FEATURES: string[] = [
  'Limited Resumes',
  'Limited Resume Analysis',
  'Limited Cover Letters',
  'Limited Job Applications Tracking',
  'Limited Mock Interviews',
  'Limited Canyon AI',
] as const

export const UNLIMITED_FEATURES: string[] = [
  'Unlimited Resumes',
  'Unlimited Resume Analysis',
  'Unlimited Cover Letters',
  'Unlimited Job Applications Tracking',
  'Unlimited Canyon AI',
  'Unlimited Mock Interviews',
] as const

export const GOLD_FEATURES: string[] = [
  'All Pro Features',
  'Guided Application Tasks',
  'Company Research Assistant',
  'Personalized Tone of Voice',
  'LinkedIn Contact Recommendations ',
  'Tailored Networking Messages',
] as const
